import React from 'react'
import Map2Gis from './components/Map2Gis'

const ContactsPage: React.FC = () => {
    return (
        <div className="flex flex-col w-[1200px] h-full p-10 rounded-3xl gap-10 items-center justify-center mb-9">
            <div className="flex flex-col w-full text-left text-[32px] font-semibold uppercase leading-9">
                Контакты
            </div>
            <div className="flex flex-row w-full h-full gap-10 items-start justify-start">
                <div className="flex flex-col w-full h-full items-start justify-start text-left bg-[#FFFFFF] text-[#000000] text-[16px] rounded-3xl p-5">
                    <p className="font-semibold">Компания:</p>
                    <p>ООО «Технологии Закупок»</p>
                    <p>ИНН 1435363820 </p>
                    <p>КПП 143501001</p>
                    <p>ОГРН 1211400010491</p>
                </div>
                <div className="flex flex-col w-full h-full items-start justify-start text-left bg-[#FFFFFF] text-[#000000] text-[16px] rounded-3xl p-5">
                    <p className="font-semibold">Юридический адрес:</p>
                    <p>
                        677000, Республика Саха (Якутия), г. Якутск, пр-т
                        Ленина, 1, оф. 625
                    </p>
                </div>
                <div className="flex flex-col w-full h-full items-start justify-start text-left bg-[#FFFFFF] text-[#000000] text-[16px] rounded-3xl p-5">
                    <p className="font-semibold">Адрес:</p>
                    <p>
                        677000, Республика Саха (Якутия), г. Якутск, пр-т
                        Ленина, 1, оф. 511
                    </p>
                </div>
            </div>
            <div className="flex flex-col w-full text-left gap-3">
                <div className="flex flex-col w-full text-left text-[24px] font-semibold leading-[24px]">
                    Мы на карте
                </div>
                <Map2Gis />
            </div>
        </div>
    )
}

export default ContactsPage
